module.exports = __webpack_public_path__ + "img/joel-crosby@1x.25d60d9a.jpg";